import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { cepMask } from '../../../utils/masks';
import { ProductSale } from '../../../interfaces/tickets/ProductSale';
import {CEPServices} from '../../../services/cep.service';

@Component({
  selector: 'ng-tickets-add-address',
  styleUrls: ['./add-address.component.scss', '../../tickets/styles/ticket.scss'],
  templateUrl: './add-address.component.html',
  providers: [CEPServices]
})
export class AddAddressComponent implements OnInit {

  @Output() nextStep = new EventEmitter();
  @Input() productSale: ProductSale;

  // Form Groups
  form: FormGroup;

  // Billing Address Controls
  addressCep: FormControl;
  addressStreet: FormControl;
  addressNumber: FormControl;
  addressAdditional: FormControl;
  addressNeighborhood: FormControl;
  addressCity: FormControl;
  addressState: FormControl;

  cepMask = cepMask;

  constructor(
    private fb: FormBuilder,
    private cepServices: CEPServices
  ) {
  }

  ngOnInit() {
    this.createFormControls();
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      zip_code: this.addressCep,
      city: this.addressCity,
      state: this.addressState,
      line_2: this.addressAdditional,
      addressStreet: this.addressStreet,
      addressNumber: this.addressNumber,
      addressNeighborhood: this.addressNeighborhood,
    });
  }

  createFormControls() {
    const { billing_address } = this.productSale;

    let addrNeighborhood;
    let addrStreet;
    let addrNumber;

    if (billing_address) {
      const { addressStreet, line_1, addressNumber, addressNeighborhood } = billing_address;
      addrStreet = addressStreet ? addressStreet : line_1.split(',')[0].trim();
      addrNumber = addressNumber ? addressNumber : line_1.split(',')[1].trim();
      addrNeighborhood = addressNeighborhood ? addressNeighborhood : line_1.split(',')[2].trim();
    }

    this.addressCep = new FormControl(billing_address && billing_address.zip_code || '', [Validators.required, Validators.minLength(9)]);
    this.addressStreet = new FormControl(addrStreet || '', [Validators.required, Validators.minLength(3)]);
    this.addressNumber = new FormControl(addrNumber || '', [Validators.required, Validators.minLength(3)]);
    this.addressAdditional = new FormControl(billing_address && billing_address.line_2 || '', [Validators.minLength(3)]);
    this.addressNeighborhood = new FormControl(addrNeighborhood || '', [Validators.required, Validators.minLength(3)]);
    this.addressCity = new FormControl(billing_address && billing_address.city || '', [Validators.required, Validators.minLength(3)]);
    this.addressState = new FormControl(billing_address && billing_address.state || '', [Validators.required, Validators.minLength(2)]);
  }

  submitForm() {
    this.markFormGroupTouched(this.form);

    if (this.form.valid) {
      const { addressStreet, addressNumber, addressNeighborhood, ...form } = this.form.value;

      this.productSale.billing_address = {
        ...form,
        addressNeighborhood,
        addressNumber,
        addressStreet,
        line_1: `${addressStreet}, ${addressNumber}, ${addressNeighborhood}`,
        country: 'BR'
      };

      this.nextStep.emit('card-confirm');
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  onChangeCep() {
    if (this.addressCep.valid) {
      this.cepServices
        .getAddressByCep(this.addressCep.value)
        .subscribe((place) => {
          this.addressNeighborhood.setValue(place.bairro);
          this.addressCity.setValue(place.localidade);
          this.addressState.setValue(place.uf);
          this.addressStreet.setValue(place.logradouro);
        });
    }
  }

  backEvent() {
    const { addressLength, billing_address } = this.productSale;

    if (addressLength) {
      if (billing_address && billing_address.editing) {
        this.nextStep.emit('card-confirm');
      } else {
        this.nextStep.emit('address-list');
      }
    } else {
      this.nextStep.emit('add-card');
    }
  }
}
